import {
    Button,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import { FC, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { API_SLUGS, ROUTES } from "../../constants";
import { axiosInstance } from "../../services/axios";
import { IAlertState, useAlertState } from "../../store/alertState";
var format = require("string-template");


interface IAddForm extends RouteComponentProps {
    updateOnly?: boolean;
    name: string;
    updateUUID?: string;
    callback?: (data: any) => void;
    preventRedirect?: boolean;
}

const DeletePolicyForm: FC<IAddForm> = ({
    history,
    match,
    updateUUID,
    name,
    preventRedirect = false,
    callback = undefined,
}) => {

    const { setMessage } = useAlertState() as IAlertState;
    const [allowDelete, setAllowDelete] = useState(false);
    const handleDelete = async () => {
        try {
            let deleteVariableResponse = await axiosInstance.delete(format(API_SLUGS.TOOL_POLICY, { id: updateUUID }));
            setMessage({ title: "Policy Deleted Successfully", type: "success" })
            if (!preventRedirect) {
                history.push(ROUTES.GENERATOR_SETS);
            }
            if (callback) {
                callback(deleteVariableResponse);
            }

        } catch (error: any) {
            setMessage({ title: `${error?.response?.data?.message}`, type: "error" })
        }

    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>

                <Typography
                    color="textPrimary"
                    sx={{ mb: 1, textAlign: "left" }}
                    variant="h6"
                >
                    Enter name to
                    delete the policy
                </Typography>

                <TextField
                    autoComplete="off"
                    sx={{ maxWidth: "50%", textAlign: "left" }}
                    size="medium"
                    fullWidth
                    name="Api"

                    placeholder={name}
                    onChange={(e: any) => {
                        setAllowDelete(e.target.value === name);
                    }}
                    required
                    variant="outlined"
                />

            </Grid>
            <Grid item xs={12}>
                <Button
                    color="error"
                    size="medium"
                    variant="contained"
                    disabled={!allowDelete}
                    onClick={() => handleDelete()}
                    sx={{ mr: 1 }}
                >
                    Delete
                </Button>
            </Grid>
        </Grid>
    );
};

export default withRouter(DeletePolicyForm);  